export class Port {
  id: number;
  code: string;
  name: string;

  regionId: number;
  regionName: string;

  countryId: number;
  countryName: string;

  latitude: number;
  longitude: number;
  coordinates: string;

  userData: {
    favorited: boolean,
    note: string
  };

  display: string;
  title: string;

  // schedules
  iconUrl: string;
  latlong: Array<number>;
  location: string;

  constructor(json: any) {
    this.id = json.id || 0;
    this.code = json.code || '';
    this.name = json.name || '';

    this.setRegion(json);
    this.setCountry(json);
    this.setCoordinates(json);

    this.userData = json.userData || {
      favorited: false,
      note: ''
    };

    this.iconUrl = '../img/port-selected.png';
    this.latlong = json.latlong || [null, null];
    this.setLocation();
    this.setDisplay();
    this.setTitle();
  }

  setRegion(json) {
    try {
      this.regionId = json.region.id || 0;
      this.regionName = json.region.name || '';
    } catch (ex) {
      this.regionId = 0;
      this.regionName = '';
    }
  }

  setCountry(json) {
    try {
      this.countryId = json.country.id || 0;
      this.countryName = json.country.name || '';
    } catch (ex) {
      this.countryId = 0;
      this.countryName = '';
    }
  }

  setCoordinates(json) {
    try {
      this.latitude = json.latlong[0] || null;
      this.longitude = json.latlong[1] || null;
      this.coordinates = `${this.latitude.toFixed(4)}, ${this.longitude.toFixed(4)}`;
    } catch (ex) {
      this.latitude = null;
      this.longitude = null;
      this.coordinates = '0.0000, 0.0000';
    }
  }

  setLocation() {
    if (this.regionName === '' || this.regionId === 0) {
      this.location = this.countryName;
    } else if (this.regionName !== '' && this.countryName === '') {
      this.location = this.regionName;
    } else {
      this.location = '';
    }
  }

  setDisplay() {
    if (this.name === 'blurred text' && this.id === 0) {
      this.display = 'blurred text';
    } else if (this.regionName !== '' && this.countryName !== '') {
      this.display = this.name + ' [' + this.code + '], ' + this.regionName + ', ' + this.countryName;
    } else if (this.regionName === '' && this.countryName !== null) {
      this.display = this.name + ' [' + this.code + '], ' + this.countryName;
    } else {
      this.display = this.name + ' [' + this.code + ']';
    }
  }

  setTitle() {
    if (this.name === 'blurred text' && this.id === 0) {
      this.title = 'blurred text';
    } else {
      this.title = this.name + ' [' + this.code + ']';
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/port.ts